export function buildChapters(config) {
  const alignments = {
    'left': 'lefty',
    'center': 'centered',
    'right': 'righty',
    'full': 'fully'
  };

  return config.chapters.map((record, idx) => {
    const container = document.createElement('div');
    container.id = record.id;
    container.classList.add('step');
    if (idx === 0) container.classList.add('active');

    const chapter = document.createElement('div');
    chapter.classList.add(config.theme);

    if (record.title) {
      const title = document.createElement('h3');
      title.innerText = record.title;
      chapter.appendChild(title);
    }

    if (record.image) {
      const image = new Image();
      image.src = record.image;
      chapter.appendChild(image);
    }

    if (record.caption) {
      const caption = document.createElement('p');
      caption.className = 'caption';
      caption.innerHTML = `<em>${record.caption}</em>`;
      chapter.appendChild(caption);
    }

    if (record.description) {
      const story = document.createElement('p');
      story.innerHTML = record.description;
      chapter.appendChild(story);
    }

    if (record.author) {
      const author = document.createElement('p');
      author.innerHTML = `<strong>By ${record.author}</strong>`;
      chapter.appendChild(author);
    }

    if (record.website) {
      const website = document.createElement('p');
      website.innerHTML = `» ${record.website}`;
      chapter.appendChild(website);
    }

    if (config.chapterReturn) {
      const returnTop = document.createElement('p');
      returnTop.className = 'returntop';
      returnTop.innerHTML = `<a href="#header">Back to top</a>`;
      chapter.appendChild(returnTop);
    }

    if (record.legend) {
      const legend = document.createElement('div');
      legend.className = 'legend';
      legend.id = `${record.id}Legend`;
      legend.innerHTML = `<div>${record.legend}</div>`;
      document.body.append(legend);
    }

    container.appendChild(chapter);
    container.classList.add(alignments[record.alignment] || 'centered');
    if (record.hidden) container.classList.add('hidden');

    return container;
  });
}

